import React, { useState, useEffect } from 'react';
import { InputGroup, InputGroupAddon, Input, InputGroupText } from 'reactstrap';
import { Search } from 'react-feather';
import { findGetParameter } from '@Utils/helpers';
import { useHistory } from 'react-router-dom';

function HeaderSearch() {
  const history = useHistory();
  const s = findGetParameter('s');
  const [searchKey, setSearchKey] = useState('');

  useEffect(() => {
    if (s) {
      setSearchKey(s);
    }
  }, [s]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchKey) {
      history.push(`/search?s=${searchKey}`);
    }
  };
  return (
    <div className="nav-item w-100 header-search">
      <form onSubmit={handleSubmit} className="w-100">
        <InputGroup className="input-group-merge" type="search" name="Search" style={{ backgroundColor: '#f5f6f8', borderRadius: '40px', padding: '4px', border: 'none', minHeight: '40px' }}>
          <Input
            className="border-0 bg-transparent"
            placeholder="Tìm kiếm"
            name="s"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            type="search"
            style={{ fontSize: '13px', boxShadow: 'none', paddingLeft: '16px' }}
          />
          <InputGroupAddon addonType="append" className="d-flex align-items-center bg-transparent border-0">
            <div className="cursor-pointer d-flex align-items-center justify-content-center" style={{ backgroundColor: '#fba92c', width: '32px', height: '32px', borderRadius: '50%' }} onClick={handleSubmit}>
              <Search color="#fff" size={16} />
            </div>
          </InputGroupAddon>
        </InputGroup>
      </form>
    </div>
  );
}

HeaderSearch.propTypes = {};

export default HeaderSearch;
